import {
  ApplyArenaReferralCodeResponseSchema, // Schemas for APIResponseSchemaMap
  GetArenaKolManagerStatusResponseSchema,
  GetArenaKolManagerDashboardResponseSchema,
  GetArenaKolManagerVolumeResponseSchema,
  ArenaKolWriteResponseSchema,
  GetArenaKolDetailResponseSchema,
  ArenaKolInviteDtoSchema,
  GetArenaKolInviteResponseSchema,
  ArenaKolManagerWriteResponseSchema,
  ListCmsArenaKolManagersResponseSchema,
  ListCmsArenaKolsResponseSchema,
  ListCmsArenaKolLinkEventsResponseSchema,
  GetArenaKolManagerRoleInviteResponseSchema,
  CmsArenaKolManagerRoleInviteDtoSchema,
  ListCmsArenaKolManagerRoleInvitesResponseSchema,
  TonConnectProofSchema,
  TonConnectPayloadSchema,
  ExchangeNameStatusSchema,
  ExchangeToStandardizedChainsMappingSchema,
  KrakenWithdrawalMethodDtoSchema,
  StringArraySchema,
  MarketNetworkSchema,
  TokenMappingArraySchema,
  TokenMetadataRecordSchema,
  FiatCurrencyMetadataSchema,
  TokenPriceResponseSchema,
  TradePathDataSchema,
  TradePathBySupportedTokensResponseSchema,
  CampaignOrderArraySchema,
  MessageResponseDtoSchema,
  GetSpotOrderHistoryResponseSchema,
  GetSpotTradesResponseSchema,
  UserStatsSchema,
  GeneralStatsSchema,
  LeaderboardEntriesSchema,
  HubUserMeResponseSchema,
  HubUserLinkWalletResponseSchema,
  HubUserLinkEmailResponseSchema,
  HubUserSignInResponseSchema,
  HubExchangeAccountSchema,
  HubExchangeAccountDisconnectionSchema,
  AutomaticStreakCguAcknowledgmentResponseSchema,
  AutomaticStreakCguStatusResponseSchema,
  HubExchangeAccountBalancesSchema,
  CheckCredentialsResponseSchema,
  GetPositionsResponseSchema,
  ApiGetFundingHistoryResponseSchema,
  DepositAddressSchema,
  ExchangeInfoSchema,
  ValidateHubDefiAddressResponseSchema,
  EstimatedPriceFromOrderBookResponseSchema,
  MarketRateSchema,
  MinAmountsSchema,
  PreparedOrderSchema,
  OrderSchema,
  OrderV2Schema,
  OHLCVSchema,
  OpenOrdersSchema,
  PopularTrendingTokensResponseSchema,
  CancelOrderStatusResponseSchema,
  MarketPairSchema,
  MarketPairV2Schema,
  OrderBookSchema,
  OrderBookMetricsSchema,
  OrderBookDeepthResponseSchema,
  TransferRoutesSchema,
  TransferInternalResponseSchema,
  TradeToEarnLeaderboardWireSchema,
  EpochsByCampaignSchema,
  MyLeaderboardEpochsSchema,
  PnlSnapshotResponseSchema,
  OpponentActivityRoomStateResponseSchema,
  PriceEventsResponseSchema,
  UserPnlStatsResponseSchema,
  CurrentUserVolumeInWindowSchema,
  CurrentUserVolumeInPhaseSchema,
  ShouldDisableTradeSchema,
  LeaderboardSimulateResponseSchema,
  BanRecordSchema,
  BanRecordResponseSchema,
  HubUserSchema,
  BannedHubUsersResponseSchema,
  HubUserSuccessRateAnalysisResponseSchema,
  ExchangeUserSuccessRateAnalysisResponseSchema,
  CampaignSuccessRateAnalysisResponseSchema,
  IpHashSuccessRateAnalysisResponseSchema,
  EpochSuccessRateAnalysisResponseSchema,
  GraphOfConvergingAddressesSchema,
  GraphIdAndCampaignArraySchema,
  SuccessResponseDtoSchema,
  RemoveNodeFromGraphResponseSchema,
  ClaimableRewardsResponseSchema,
  ClaimableSoonRewardsResponseSchema,
  MerklClaimableRewardsResponseSchema,
  MaintenanceStatusResponseSchema,
  CreateStreakResponseSchema,
  StreakResponseSchema,
  StreakSummaryResponseSchema,
  CancelStreakResponseSchema,
  AutomaticStreakConfigResponseSchema,
  AutomaticStreakConfigSchema,
  StreakResponseV2Schema,
  StreakSummaryResponseSchemaV2,
  JoinStreakQueueResponseSchemaV2,
  LeaveStreakQueueResponseSchemaV2,
  GetUserStreakQueueItemResponseSchemaV2,
  IncreaseQueuePriorityResponseSchemaV2,
  GetPriorityTicketBalanceResponseSchemaV2,
  AdminGrantPriorityTicketsResponseSchemaV2,
  AdminGetStreakQueueItemsByCampaignResponseSchema,
  EpochLimitStatusResponseSchema,
  MinimumRequiredBalanceResponseSchema,
  EpochsWithStreaksResponseSchema,
  AutopilotUsersResponseSchema,
  AutopilotTradesResponseSchema,
  GetInternalCacheResponseSchema,
  OAuthInitResponseSchema,
  NumberSchema,
  ReferralCodeResponseSchema,
  referralSchema,
  ReferrerEligibilityProgressSchema,
  UserReferralsSchema,
  RefereeEligibilityProgressSchema,
  ReferralEligibilityTargetAndCurrentDecimalSchema,
  ReferralSettingsResponseSchema,
  ReferrerStatsSchema,
  RefereeStatsSchema,
  RefereeEligibleResponseSchema,
  AmbassadorEligibilityResponseSchema,
  RefereesCountSchema,
  VolumeByRefereeSchema,
  VolumeByExchangeSchema,
  RewardsStatisticsSchema,
  VolumeByReferrerSchema,
  ReferrerReferreesSchema,
  ReferrerDetailsSchema,
  ActiveRefereesSchema,
  ReferralStatusRateSchema,
  NullableStringSchema,
  ReferralCodeSchema,
  QuestDtoSchema,
  QuestCompletionSchema,
  QuestProgressSchema,
  QuestEligibilityItemSchema,
  XPostDataWithCommentDtoSchema,
  UserTicketsResponseDtoSchema,
  TTECampaignSummaryResponseSchema,
  GetArenaGeneralLeaderboardResponseSchema,
  GetArenaGeneralLeaderboardPositionResponseSchema,
  GetArenaGeneralLeaderboardStatsResponseSchema,
  GetArenaRecentWinsResponseSchema,
  GetArenaWeeklyLeaderboardResponseSchema,
  GetArenaWeeklyLeaderboardPositionResponseSchema,
  GetArenaWeeklyLeaderboardPositionsResponseSchema,
  GetArenaWeeklyCrownsResponseSchema,
  GetArenaPlayerProfileResponseSchema,
  GetArenaPlayerIdentitiesResponseSchema,
  UploadArenaAvatarResponseSchema,
  UpdateArenaQuoteResponseSchema,
  GetArenaFriendsListResponseSchema,
  GetArenaFriendsResponseSchema,
  LookupArenaFriendResponseSchema,
  CreateArenaFriendInviteResponseSchema,
  ClaimArenaFriendInviteResponseSchema,
  PrivateCompetitionRoomDtoSchema,
  MyPrivateCompetitionRoomsResponseSchema,
  GetArenaChatHistoryResponseSchema,
  SendArenaChatMessageResponseSchema,
  GetArenaSupportConversationResponseSchema,
  GetArenaSupportMessagesResponseSchema,
  ArenaSupportAcceptedResponseSchema,
  CmsArenaSupportConversationsResponseSchema,
  CmsArenaSupportMessagesResponseSchema,
  CmsArenaSupportKbEntriesResponseSchema,
  CmsArenaSupportAgentPlaygroundResponseSchema,
  CmsArenaSupportAgentRunsResponseSchema,
  CmsArenaSupportGoldenCasesResponseSchema,
  ArenaSupportGoldenCaseSchema,
  CmsStartArenaSupportEvalRunResponseSchema,
  CmsArenaSupportEvalRunsResponseSchema,
  ArenaSupportEvalRunSchema,
  CmsArenaSupportAgentDashboardResponseSchema,
  GetArenaDiscordStatusResponseSchema,
  ArenaQualificationConfigSchema,
  ArenaQualificationStateSchema,
  ArenaSurveyConfigSchema,
  ListArenaSurveyResponsesResponseSchema,
  ArenaSurveyStateSchema,
  ArenaMarketFavoritesSchema,
  GetArenaQueueStatusResponseSchema,
  ArenaTrafficCurveDtoSchema,
  GetArenaGeoEligibilityResponseSchema,
  GetConsentRegionResponseSchema,
  ArenaCompetitionFinalizationSchema,
  ArenaCampaignAccountPnlsSchema,
  BattleRoyaleStateDtoSchema,
  ArenaCancelledCompetitionDtoSchema,
  ArenaBattleRecordSchema,
  GetArenaOpeningMoveResponseSchema,
  ArenaMyCampaignStakeSchema,
  ArenaCampaignPayoutCapsDtoSchema,
  ArenaQueueDisplaySettingsDtoSchema,
  ArenaReengagementSettingsDtoSchema,
  ArenaPrivateCompetitionSettingsDtoSchema,
  GetArenaPrivateCompetitionRakePolicyResponseSchema,
  ArenaPlatformSettingsDtoSchema,
  ArenaReferralConfigDtoSchema,
  ListArenaReferralOverridesResponseSchema,
  ArenaReferralOverrideWriteResponseSchema,
  GetArenaReferralsResponseSchema,
  GetArenaClansResponseSchema,
  GetArenaClanBadgesResponseSchema,
  GetMyArenaClanResponseSchema,
  GetArenaClanInviteLinkResponseSchema,
  GetArenaClanResponseSchema,
  ArenaClanConfigDtoSchema,
  ListCmsArenaClansResponseSchema,
  CmsArenaClanDtoSchema,
  ListCmsArenaClanMembersResponseSchema,
  ListCmsArenaClanTournamentsResponseSchema,
  GetCmsArenaClanTournamentResponseSchema,
  ListCmsArenaReferrersResponseSchema,
  ListCmsArenaRefereesResponseSchema,
  ArenaEventConfigDtoSchema,
  CanberraiConfigDtoSchema,
  CanberraiPlayerDifficultyDtoSchema,
  ExperimentDtoSchema,
  ArenaBotSchedulerConfigDtoSchema,
  ArenaTrafficCurveConfigDtoSchema,
  GetArenaMatchmakingConfigsResponseSchema,
  GetArenaMatchmakingTiersResponseSchema,
  GetSpinAndGoConfigsResponseSchema,
  GetSpinAndGoUnconsumedResponseSchema,
  SpinAndGoPublicConfigResponseSchema,
  GetMyArenaEntryResponseSchema,
  GetMyArenaTicketsResponseSchema,
  GetMyArenaQuestStateResponseSchema,
  GetArenaStarterPackResponseSchema,
  GetArenaQuestRewardResponseSchema,
  GetArenaTicketConfigurationResponseSchema,
  GetArenaTicketsForUserResponseSchema,
  ArenaTicketLinkPreviewResponseSchema,
  ClaimArenaTicketLinkResponseSchema,
  ListArenaTicketLinksResponseSchema,
  CmsArenaTicketLinkDtoSchema,
  ArenaAffiliateApplicationDtoSchema,
  ListArenaAffiliateApplicationsResponseSchema,
  GetMyBigArenaCompetitionRegistrationResponseSchema,
  SubmitBigArenaCompetitionRegistrationResponseSchema,
  ListBigArenaCompetitionRegistrationsResponseSchema,
  BigArenaCompetitionRegistrationDtoSchema,
  ListBigArenaCompetitionPriorityCodesResponseSchema,
  GenerateBigArenaCompetitionPriorityCodesResponseSchema,
  BigArenaCompetitionPriorityCodeDtoSchema,
  ArenaActiveTournamentResponseSchema,
  ArenaCurrentTournamentResponseSchema,
  ArenaTournamentDtoSchema,
  ArenaTournamentMeResponseSchema,
  ArenaTournamentRoundLeaderboardResponseSchema,
  ArenaTournamentSniperBoardResponseSchema,
  ArenaTournamentStreakBoardResponseSchema,
  CmsArenaTournamentDtoSchema,
  ListCmsArenaTournamentDuelsResponseSchema,
  ListCmsArenaTournamentParticipantsResponseSchema,
  ListCmsArenaTournamentVoidedDuelsResponseSchema,
  ListCmsArenaTournamentsResponseSchema,
  SaveArenaTournamentResponseSchema,
  SkipArenaOnboardingResponseSchema,
  CompleteArenaOnboardingResponseSchema,
  ArenaOnboardingProjectionSchema,
  GetArenaRematchEligibilityResponseSchema,
  GetArenaForfeitEligibilityResponseSchema,
  CedeArenaCampaignOptInResponseSchema,
  CedeArenaMyCampaignOptInsResponseSchema,
  CedeArenaCampaignJoinersResponseSchema,
  CedeArenaCampaignOptInCountsResponseSchema,
  AdminListArenaEntriesResponseSchema,
  ArenaOpsOverviewKpisResponseSchema,
  ArenaOpsOverviewCoverageRingsResponseSchema,
  ArenaOpsOverviewReconciliationResponseSchema,
  ArenaOpsUsersResponseSchema,
  ArenaOpsUsersKpisResponseSchema,
  ArenaOpsUsersLedgerIdentityResponseSchema,
  ArenaOpsUsersBalanceDistributionResponseSchema,
  ArenaOpsUsersMovementsResponseSchema,
  ArenaOpsMoneyPeriodFlowsResponseSchema,
  ArenaOpsMoneyHouseInjectionResponseSchema,
  ArenaOpsMoneyRakeProvenanceResponseSchema,
  ArenaOpsMoneyRevenuePerDayResponseSchema,
  ArenaOpsMoneyDepositsResponseSchema,
  ArenaOpsMoneyWithdrawalsResponseSchema,
  ArenaOpsMoneyFreeTicketValueResponseSchema,
  ArenaOpsMoneySankeyResponseSchema,
  ArenaOpsMoneyMovementsResponseSchema,
  ArenaOpsMoneyWithdrawalRequestsResponseSchema,
  ArenaOpsTicketsLifecycleResponseSchema,
  ArenaOpsTicketsBySourceResponseSchema,
  ArenaOpsTicketLinksResponseSchema,
  ArenaOpsTicketsOutcomesResponseSchema,
  ArenaOpsMatchmakingUniverseResponseSchema,
  ArenaOpsMatchmakingPairingRateSeriesResponseSchema,
  ArenaOpsMatchmakingWaitSeriesResponseSchema,
  ArenaOpsMatchmakingWaitCdfResponseSchema,
  ArenaOpsMatchmakingEntriesByBuyInResponseSchema,
  ArenaOpsMatchmakingQueueHealthResponseSchema,
  ArenaOpsMatchmakingMatchesByHourResponseSchema,
  ArenaOpsMatchmakingQueueDepthResponseSchema,
  AdminMarkArenaEntryPaidResponseSchema,
  AdminCancelArenaEntryResponseSchema,
  ListCedeArenaCompetitionBlueprintsResponseSchema,
  GetCedeArenaCompetitionBlueprintResponseSchema,
  ListUnlinkedArenaCompetitionsResponseSchema,
  ListArenaCompetitionsResponseSchema,
  ListArenaWhitelistedUsersResponseSchema,
  ArenaWhitelistedUserDtoSchema,
  GetArenaVirtualBalanceResponseSchema,
  GetArenaDepositAddressResponseSchema,
  CreateArenaDepositResponseSchema,
  RecordArenaDepositMethodResponseSchema,
  GetArenaDepositMethodsResponseSchema,
  GetArenaCrossmintSetupResponseSchema,
  RegisterArenaCrossmintWalletResponseSchema,
  VerifyArenaCrossmintWalletResponseSchema,
  CreateArenaCrossmintOrderResponseSchema,
  GetArenaCrossmintOrderResponseSchema,
  GetArenaOpenCrossmintOrdersResponseSchema,
  CreateArenaWithdrawResponseSchema,
  ListArenaWithdrawsResponseSchema,
  GetArenaWithdrawClaimResponseSchema,
  ListArenaBalanceMovementsResponseSchema,
  ListArenaRecentPayoutsResponseSchema,
  ListArenaFeedResponseSchema,
  TradeToEarnCampaignSchema,
  RewardTokenMetadataResponseSchema,
  TradeToEarnCampaignWithStatsSchema,
  TradeToEarnCampaignSummarySchema,
  CampaignAnalyticsEpochGroupsSchema,
  CampaignVaultDetailSchema,
  CampaignAnalyticsEpochsSchema,
  CampaignAnalyticsListItemSchema,
  CampaignVaultListItemSchema,
  TradeToEarnCampaignWithPrivateFieldsSchema,
  HteCampaignPreviewsListResponseSchema,
  HteCampaignFullDataDtoSchema,
  JoinCampaignResponseSchema,
  GetLeaderboardResponseSchema,
  GetParticipantStatusResponseSchema,
  GetEpochStatisticsResponseSchema,
  HoldToEarnCampaignSchema,
  ListRewardsResponseSchema,
  GetUserTicketsResponseSchema,
  GetUserSpinResultsResponseSchema,
  GetThresholdProgressResponseSchema,
  VoidResponseDtoSchema,
  GetRecentWinnersResponseSchema,
  SpinningWheelEligibilityResponseSchema,
  GetHyperliquidAgentSchema,
  HyperliquidStatusSchema,
  HyperliquidReferrerEligibilityResultSchema,
  AddParadexAccountSchema,
  AddExtendedAccountSchema,
  ExtendedPrepareResultSchema,
  AddGrvtAccountSchema,
  GrvtBuilderPrepareResultSchema,
  AddHibachiAccountSchema,
  ConnectHibachiResultSchema,
  AddDecibelAccountSchema,
  AuthorizeDecibelDelegationResultSchema,
  PrepareDecibelDelegationResultSchema,
  GetHotstuffAgentSchema,
  HotstuffStatusSchema,
  KatanaDelegationPrepareResultSchema,
  AddKatanaAccountSchema,
  RisePrepareResultSchema,
  AddRiseAccountSchema,
  SkywalkerStatsSchema,
  EpochHourlyVolumeResponseSchema,
  SkywalkerEpochTraderStatsSchema,
  SkywalkerCampaignUsersResponseSchema,
  SkywalkerUserVolumeDetailSchema,
  SkywalkerUserGeographySchema,
  SkywalkerGlobalUserGeographySchema,
  SkywalkerHteCampaignSchema,
  SkywalkerHteStatsSchema,
  SkywalkerHteInternalSchema,
  GetSeasonsResponseSchema,
  GetUserRankDataResponseSchema,
  GetTop50ResponseSchema,
  HallOfFameCountdownRewardsResponseSchema,
  swapQuoteResponseSchema,
  portfolioResponseSchema,
  SwapTokenByAddressResponseSchema,
  getTokensForSwapResponseSchema,
  getDexPairsResponseSchema,
  submitOnchainTransactionResponseSchema,
  WalletAgeCheckResultSchema,
  OnchainSystemMetadataSchema,
  CashbackStatusResponseSchema,
  CashbackConfigResponseSchema,
  AdminCashbackConfigResponseSchema,
  SaveCashbackConfigResponseSchema,
  PolymarketCredentialsCheckResponseSchema,
  AdminTTECampaignPreviewResponseSchema,
  ListMonitoredCampaignsResponseSchema,
  GetCampaignHealthResponseSchema,
  CampaignPartnerDtoSchema,
  SaveCampaignPartnersResponseSchema,
  ListCampaignPartnersResponseSchema,
  ListFilesResultSchema,
  ListBlacklistAddressesResponseSchema,
  ListWhitelistAddressesResponseSchema,
  ListAdminHubUsersResponseSchema,
  AdminOnchainConfigResponseSchema,
  UpdateOnchainConfigResponseDtoSchema,
  CpcCreateSimulationResponseSchema,
  CpcListSimulationsResponseSchema,
  CpcCancelSimulationResponseSchema,
  CpcVerifyWalletResponseSchema,
  SaveQuestDtoSchema,
  FeatureFlagsBulkSuccessResponseSchema,
  FeatureFlagsCmsSuccessResponseSchema,
  GetFeatureFlagsByPageResultSchema,
  HubFeatureFlagsResponseSchema,
  HubFeatureFlagsLegacyResponseSchema,
  GetHubBannersByPageResultSchema,
  HubBannerDtoSchema,
  GetActiveHubBannersResultSchema,
  CedeFlowTradeAndEarnCompetitionDtoSchema,
  GetCedeFlowTradeAndEarnCompetitionsByPageResultSchema,
  GetActiveCedeFlowTradeAndEarnCompetitionsResultSchema,
  GetHubUpdatesByPageResultSchema,
  HubUpdateDtoSchema,
  GetPublishedHubUpdatesResultSchema,
  GetArenaAnnouncementsByPageResultSchema,
  GetGeoRestrictionsByPageResultSchema,
  ArenaAnnouncementDtoSchema,
  GetPublishedArenaAnnouncementsResultSchema,
  GetSpinningWheelConfigsByPageResultSchema,
  SpinningWheelConfigDtoSchema,
  GetOnboardingStepsByPageResultSchema,
  OnboardingStepDtoSchema,
  GetPublishedOnboardingStepsResultSchema,
  GetTradeTutorialStepsByPageResultSchema,
  TradeTutorialStepDtoSchema,
  GetPublishedTradeTutorialStepsResultSchema,
  LiveCampaignEpochsDataSchema,
  EpochVolumeTargetComputationRecordSchema,
  SocialAccountDtoSchema,
  UploadFileResponseSchema, // Types for local use (not in APIResponseSchemaMap)
  GetMyPermissionsResponseSchema,
  GetAllUsersPermissionsResponseSchema,
  CmsPermissionsSuccessResponseSchema,
  type GasData,
  type DetailedChain,
  PolymarketEventsResponseSchema,
  TradeTickerSchema,
  AirdropFarmingBotDtoSchema,
  ListAirdropFarmingBotsResponseSchema,
  AirdropFarmingBotAggregatesResponseSchema,
  AirdropFarmingBotPerformanceResponseSchema,
  AirdropFarmingMinCapitalResponseSchema,
  AirdropFarmingAvailableCapitalResponseSchema,
  AirdropFarmingSuggestPairsResponseSchema,
  AirdropFarmingFeeTierResponseSchema,
  AirdropFarmingBuilderFeesResponseSchema,
  AirdropFarmingLeaderboardResponseSchema,
  AirdropFarmingLeaderboardStatsResponseSchema,
  AirdropFarmingLeaderboardPositionResponseSchema,
  AirdropFarmingPendingRatingResponseSchema,
  GetActiveMaintenanceWindowResponseSchema,
  OrderFillLeaderboardResponseSchema,
  OrderFillLeaderboardPositionResponseSchema,
  OrderFillLeaderboardStatsResponseSchema,
  OrderFillVolumesBySlugsResponseSchema,
  DeltaNeutralBotDtoSchema,
  DeltaNeutralLegInfoResponseSchema,
  MarkPriceSchema,
  PaginatedFundingRateSummariesSchema,
  ArenaStarterPackPreviewResponseSchema,
  ArenaQuestPreviewResponseSchema,
} from "@cede/types";
import { API_ENDPOINT } from "./endpoints";
import z from "zod";

// TODO: Ideally all these types would be exported from @cede/types as they are not utils methods

export type TokenPrices = {
  [key: string]: number;
};

export type GasPriceResponseDto = GasData[];

export type DetailedChainsResponseDto = DetailedChain[];

export type AccountBalanceResponseDto = {
  balances: AccountBalance[];
  message: string;
};

// Account Balance
export type AccountBalance = {
  protocolSymbol: string | null;
  protocolName: string;
  positionType: string;
  quantity: number;
  value: number; // value in USD
  price: number; // price per token in USD
  changes: {
    absolute_1d: number;
    percent_1d: number;
  };
  token: Currency;
  updatedAt: string;
  chainId: string;
};

export type Currency = {
  name: string;
  icon: string;
  symbol: string;
};

export const AllFiatCurrenciesSchema = z.record(z.string(), z.boolean());
export type AllFiatCurrencies = z.infer<typeof AllFiatCurrenciesSchema>;

export * from "./endpoints";

// Split in two halves purely to keep declaration emit under TypeScript's
// serialization ceiling (TS7056) — `APIResponseSchemaMap` below is the single
// map every consumer reads. Add new entries to either half.
export const APIResponseSchemaMapPart1 = {
  //-------- AUTH --------
  [API_ENDPOINT.TON_CONNECT_VALIDATE_PROOF]: TonConnectProofSchema,
  [API_ENDPOINT.TON_CONNECT_GENERATE_PAYLOAD]: TonConnectPayloadSchema,

  //-------- EXCHANGE --------
  [API_ENDPOINT.EXCHANGES_STATUS]: z.array(ExchangeNameStatusSchema),
  [API_ENDPOINT.STANDARDIZED_CHAINS]: ExchangeToStandardizedChainsMappingSchema,
  [API_ENDPOINT.KRAKEN_WITHDRAWAL_NETWORKS_INFO]: z.array(KrakenWithdrawalMethodDtoSchema),

  //-------- TOKENS --------
  [API_ENDPOINT.SUPPORTED_TOKENS_BY_EXCHANGE]: StringArraySchema,
  [API_ENDPOINT.SUPPORTED_NETWORKS_BY_EXCHANGE]: z.array(MarketNetworkSchema),
  [API_ENDPOINT.TOKENS_MAPPING]: TokenMappingArraySchema,
  [API_ENDPOINT.TOKENS_METADATA]: TokenMetadataRecordSchema,

  //-------- FIAT --------
  [API_ENDPOINT.FIAT_CURRENCIES]: z.array(FiatCurrencyMetadataSchema),
  [API_ENDPOINT.ALL_FIAT_CURRENCIES]: AllFiatCurrenciesSchema,

  //-------- PRICE --------
  [API_ENDPOINT.PRICES]: TokenPriceResponseSchema,

  //-------- TRADE --------
  [API_ENDPOINT.TRADE_PATH]: z.array(TradePathDataSchema),
  [API_ENDPOINT.TRADE_PATH_BY_SUPPORTED_TOKENS]: TradePathBySupportedTokensResponseSchema,

  //-------- TRADE REPORTING --------
  [API_ENDPOINT.CAMPAIGN_OPEN_ORDERS]: CampaignOrderArraySchema,
  [API_ENDPOINT.HUB_TRADE_VERIFY_ORDER]: MessageResponseDtoSchema,

  //-------- TRADE HISTORY --------
  [API_ENDPOINT.SPOT_ORDERS]: GetSpotOrderHistoryResponseSchema,
  [API_ENDPOINT.SPOT_TRADES]: GetSpotTradesResponseSchema,

  //-------- STATS --------
  [API_ENDPOINT.USER_STATS]: UserStatsSchema,
  [API_ENDPOINT.HUB_STATS]: GeneralStatsSchema,
  [API_ENDPOINT.HUB_GLOBAL_LEADERBOARD]: LeaderboardEntriesSchema,

  //-------- USERS --------
  [API_ENDPOINT.HUB_USER_ME]: HubUserMeResponseSchema,
  [API_ENDPOINT.HUB_USER_SIGNIN]: HubUserSignInResponseSchema,
  [API_ENDPOINT.HUB_USER_LINK_WALLET]: HubUserLinkWalletResponseSchema,
  [API_ENDPOINT.HUB_USER_LINK_EMAIL]: HubUserLinkEmailResponseSchema,
  [API_ENDPOINT.HUB_CREATE_EXCHANGE_ACCOUNT]: z.union([
    HubExchangeAccountSchema, // Create exchange account
    MessageResponseDtoSchema, // Delete exchange account
  ]),
  [API_ENDPOINT.HUB_EXCHANGE_ACCOUNT_DISCONNECTION]: z.array(HubExchangeAccountDisconnectionSchema),
  [API_ENDPOINT.HUB_USER_NICKNAME]: z.object({ nickname: z.string() }),
  [API_ENDPOINT.HUB_USER_NICKNAME_AVAILABLE]: z.object({ available: z.boolean() }),
  [API_ENDPOINT.CEDE_ARENA_STARTER_PACK]: ArenaStarterPackPreviewResponseSchema,
  [API_ENDPOINT.HUB_USER_PREFERRED_SOCIAL]: z.object({ socialName: z.string().nullable() }),
  [API_ENDPOINT.HUB_USER_SOCIAL_VISIBILITY]: z.object({ enabled: z.boolean() }),
  [API_ENDPOINT.HUB_USER_PROFILE_AVATAR]: UploadArenaAvatarResponseSchema,
  [API_ENDPOINT.HUB_USER_PROFILE_AVATAR_DELETE]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_USER_PROFILE_QUOTE]: UpdateArenaQuoteResponseSchema,
  // POST answers `saved`, DELETE answers `deleted` — one endpoint, both verbs.
  [API_ENDPOINT.WEB_PUSH_SUBSCRIPTIONS]: z.object({
    saved: z.boolean().optional(),
    deleted: z.boolean().optional(),
  }),
  [API_ENDPOINT.HUB_USER_AUTOMATIC_STREAK_CGU_ACKNOWLEDGMENT]: AutomaticStreakCguAcknowledgmentResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_CGU_STATUS]: AutomaticStreakCguStatusResponseSchema,

  //-------- PORTFOLIO --------
  [API_ENDPOINT.HUB_EXCHANGE_ACCOUNT_BALANCES]: HubExchangeAccountBalancesSchema,
  [API_ENDPOINT.HUB_EXCHANGE_MARGIN_ASSET_MODE]: z.object({ assetMode: z.enum(["single", "multi"]) }),
  [API_ENDPOINT.HUB_EXCHANGE_ACCOUNT_CHECK_CREDENTIALS]: CheckCredentialsResponseSchema,
  [API_ENDPOINT.HUB_EXCHANGE_ACCOUNT_POSITIONS]: GetPositionsResponseSchema,
  [API_ENDPOINT.HUB_EXCHANGE_ACCOUNT_FUNDING_HISTORY]: ApiGetFundingHistoryResponseSchema,
  [API_ENDPOINT.HUB_DEPOSIT_ADDRESS]: DepositAddressSchema,

  //-------- EXCHANGES --------
  [API_ENDPOINT.HUB_SUPPORTED_EXCHANGES]: z.array(ExchangeInfoSchema),

  //-------- HUB TRADE --------
  [API_ENDPOINT.VALIDATE_DEFI_ADDRESS]: ValidateHubDefiAddressResponseSchema,
  [API_ENDPOINT.HUB_TRADE_PERPS_PNL_OPT_IN]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_TRADE_ESTIMATE_PRICE_FROM_ORDER_BOOK]: EstimatedPriceFromOrderBookResponseSchema,
  [API_ENDPOINT.HUB_TRADE_PUBLIC_MARKET_RATE]: MarketRateSchema,
  [API_ENDPOINT.HUB_TRADE_MIN_AMOUNTS]: MinAmountsSchema,
  [API_ENDPOINT.HUB_TRADE_PREPARE_ORDER]: PreparedOrderSchema,
  [API_ENDPOINT.HUB_TRADE_CREATE_ORDER]: OrderV2Schema,
  [API_ENDPOINT.HUB_TRADE_MAX_LEVERAGE]: z.object({ maxLeverage: z.number().nullable() }),
  [API_ENDPOINT.HUB_TRADE_RETRIEVE_ORDER]: OrderSchema,
  [API_ENDPOINT.HUB_TRADE_OPEN_ORDERS]: OpenOrdersSchema,
  [API_ENDPOINT.HUB_TRADE_OHLCV]: z.array(OHLCVSchema),
  [API_ENDPOINT.HUB_TRADE_POPULAR_TOKENS]: PopularTrendingTokensResponseSchema,
  [API_ENDPOINT.HUB_TRADE_CANCEL_ORDER]: CancelOrderStatusResponseSchema,

  //-------- HUB TRADE PUBLIC --------
  // One malformed pair from the upstream CCXT adapter (e.g. HL occasionally
  // returns a pair with `base: undefined`) must not invalidate the whole
  // response — drop bad entries, keep the well-formed ones. Drops surface
  // via console.warn so silent CCXT shape drift stays visible.
  [API_ENDPOINT.HUB_TRADE_MARKET_PAIRS]: z.array(z.unknown()).transform((arr) =>
    arr.flatMap((item, index) => {
      const parsed = MarketPairSchema.safeParse(item);
      if (parsed.success) return [parsed.data];
      // eslint-disable-next-line no-console
      console.warn("[market-pairs] dropped malformed pair", {
        index,
        issues: parsed.error.issues.slice(0, 3),
      });
      return [];
    }),
  ),
  // Admin market-pairs — consumers (the CMS picker) filter the raw rows themselves.
  [API_ENDPOINT.ADMIN_HUB_TRADE_MARKET_PAIRS]: z.array(z.unknown()),
  [API_ENDPOINT.HUB_TRADE_MARKET_PAIRS_V2]: z.array(z.unknown()).transform((arr) =>
    arr.flatMap((item, index) => {
      const parsed = MarketPairV2Schema.safeParse(item);
      if (parsed.success) return [parsed.data];
      // eslint-disable-next-line no-console
      console.warn("[market-pairs-v2] dropped malformed pair", {
        index,
        issues: parsed.error.issues.slice(0, 3),
      });
      return [];
    }),
  ),
  [API_ENDPOINT.HUB_TRADE_ORDER_BOOK]: OrderBookSchema,
  [API_ENDPOINT.HUB_TRADE_ORDER_BOOK_METRICS]: OrderBookMetricsSchema,
  [API_ENDPOINT.HUB_TRADE_ORDER_BOOK_DEPTH]: OrderBookDeepthResponseSchema,
  [API_ENDPOINT.HUB_TRADE_TICKER]: TradeTickerSchema,
  [API_ENDPOINT.HUB_TRADE_MARK_PRICE]: MarkPriceSchema,

  //-------- TRANSFER --------
  [API_ENDPOINT.HUB_TRANSFER_ROUTES]: TransferRoutesSchema,
  [API_ENDPOINT.HUB_TRANSFER_INTERNAL]: TransferInternalResponseSchema,

  //-------- LEADERBOARD --------
  [API_ENDPOINT.LEADERBOARD]: TradeToEarnLeaderboardWireSchema,
  [API_ENDPOINT.EPOCHS_BY_CAMPAIGN]: EpochsByCampaignSchema,
  [API_ENDPOINT.HUB_USER_VOLUME_IN_WINDOW]: CurrentUserVolumeInWindowSchema,
  [API_ENDPOINT.USER_PHASE_VOLUME]: CurrentUserVolumeInPhaseSchema,
  [API_ENDPOINT.PNL_SNAPSHOTS]: PnlSnapshotResponseSchema,
  [API_ENDPOINT.PNL_PRICE_EVENTS]: PriceEventsResponseSchema,
  [API_ENDPOINT.USER_PNL_STATS]: UserPnlStatsResponseSchema,
  [API_ENDPOINT.HUB_LEADERBOARD_SHOULD_DISABLE_TRADE]: ShouldDisableTradeSchema,
  [API_ENDPOINT.HUB_LEADERBOARD_MY_EPOCHS]: MyLeaderboardEpochsSchema,
  [API_ENDPOINT.ARENA_OPPONENT_ACTIVITY]: OpponentActivityRoomStateResponseSchema,

  //-------- ADMIN LEADERBOARD --------
  [API_ENDPOINT.HUB_LEADERBOARD_SIMULATE]: LeaderboardSimulateResponseSchema,
  [API_ENDPOINT.HUB_LEADERBOARD_CAMPAIGNS]: StringArraySchema,

  //-------- BAN --------
  [API_ENDPOINT.HUB_BAN_RECORDS]: z.union([z.array(BanRecordSchema), SuccessResponseDtoSchema]),
  [API_ENDPOINT.HUB_BANNED_USERS]: BannedHubUsersResponseSchema,
  [API_ENDPOINT.HUB_BAN_RECORDS_USER_IP_HASHES]: BanRecordResponseSchema,
  [API_ENDPOINT.HUB_BAN_RECORDS_USER_EXCHANGE_ACCOUNTS]: BanRecordResponseSchema,
  [API_ENDPOINT.HUB_USER_AFFECTED_BY_BAN_RECORD]: z.array(HubUserSchema),

  //-------- ANTI BOT ANALYSIS --------
  [API_ENDPOINT.ANALYSIS_HUB_USER_SUCCESS_RATE]: HubUserSuccessRateAnalysisResponseSchema,
  [API_ENDPOINT.ANALYSIS_EXCHANGE_USER_SUCCESS_RATE]: ExchangeUserSuccessRateAnalysisResponseSchema,
  [API_ENDPOINT.ANALYSIS_CAMPAIGN_SUCCESS_RATE]: CampaignSuccessRateAnalysisResponseSchema,
  [API_ENDPOINT.ANALYSIS_IP_HASH_SUCCESS_RATE]: IpHashSuccessRateAnalysisResponseSchema,
  [API_ENDPOINT.ANALYSIS_EPOCH_SUCCESS_RATE]: EpochSuccessRateAnalysisResponseSchema,

  //-------- SISTER ADDRESSES IDENTIFICATION --------
  [API_ENDPOINT.HUB_GRAPH_OF_CONVERGING_ADDRESSES]: GraphOfConvergingAddressesSchema,
  [API_ENDPOINT.HUB_CONVERGING_ADDRESSES_GRAPH_IDS_AND_CAMPAIGN]: GraphIdAndCampaignArraySchema,
  [API_ENDPOINT.HUB_CONVERGING_ADDRESSES_UPDATE_GRAPHS]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_CONVERGING_ADDRESSES_REMOVE_NODE_FROM_GRAPH]: RemoveNodeFromGraphResponseSchema,

  //-------- REWARDS --------
  // Query params: { defiAddress: string, campaignTypes?: string } (comma-separated: "TTE,HTE,SPINNING_WHEEL")
  [API_ENDPOINT.HUB_REWARDS_CLAIMABLE]: ClaimableRewardsResponseSchema,
  // Query params: { defiAddress: string, campaignTypes?: string } (comma-separated: "TTE,HTE,SPINNING_WHEEL")
  [API_ENDPOINT.HUB_REWARDS_CLAIMABLE_SOON]: ClaimableSoonRewardsResponseSchema,
  // Query params: { defiAddress: string }
  [API_ENDPOINT.HUB_REWARDS_MERKL_CLAIMABLE]: MerklClaimableRewardsResponseSchema,
  // Query params: { defiAddress: string, campaignTypes?: string } (comma-separated: "TTE,HTE,SPINNING_WHEEL")
  [API_ENDPOINT.HUB_REWARDS_SIMULATE]: SuccessResponseDtoSchema,

  //-------- MAINTENANCE --------
  [API_ENDPOINT.HUB_MAINTENANCE_STATUS]: MaintenanceStatusResponseSchema,

  //-------- AUTOMATIC STREAK --------
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_CREATE]: CreateStreakResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_CREATE_V2]: CreateStreakResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_LIST]: z.array(StreakSummaryResponseSchema),
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_GET]: StreakResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_CANCEL]: CancelStreakResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_CONFIG]: AutomaticStreakConfigResponseSchema,
  // V2
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_LIST_V2]: z.array(StreakSummaryResponseSchemaV2),
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_GET_V2]: StreakResponseV2Schema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_CANCEL_V2]: CancelStreakResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_EPOCH_LIMIT]: EpochLimitStatusResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_RECENTLY_CANCELLED]: z.array(StreakSummaryResponseSchemaV2),
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_MINIMUM_REQUIRED_BALANCE]: MinimumRequiredBalanceResponseSchema,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_JOIN_QUEUE_V2]: JoinStreakQueueResponseSchemaV2,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_LEAVE_QUEUE_V2]: LeaveStreakQueueResponseSchemaV2,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_GET_QUEUE_ITEM_V2]: GetUserStreakQueueItemResponseSchemaV2,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_QUEUE_PRIORITY_TOPUP_V2]: IncreaseQueuePriorityResponseSchemaV2,
  [API_ENDPOINT.HUB_AUTOMATIC_STREAK_PRIORITY_TICKETS]: GetPriorityTicketBalanceResponseSchemaV2,

  //-------- CACHE --------
  [API_ENDPOINT.HUB_GET_INTERNAL_CACHE]: GetInternalCacheResponseSchema,
  [API_ENDPOINT.HUB_GET_ACTIVE_CACHE_KEYS]: StringArraySchema,
  [API_ENDPOINT.HUB_DELETE_FROM_CACHE]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_DELETE_FROM_CACHE_BULK]: SuccessResponseDtoSchema,

  //-------- OAUTH --------
  [API_ENDPOINT.HUB_OAUTH_INIT]: OAuthInitResponseSchema,

  //-------- EVENTS --------
  [API_ENDPOINT.HUB_SEND_EVENT]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_SEND_EVENTS_BULK]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_SET_PEOPLE]: SuccessResponseDtoSchema,

  //-------- SOCIALS --------
  [API_ENDPOINT.HUB_SOCIALS_ACCOUNTS]: z.array(SocialAccountDtoSchema),
  [API_ENDPOINT.HUB_SOCIAL_OAUTH_INIT]: OAuthInitResponseSchema,
  [API_ENDPOINT.HUB_SOCIAL_OAUTH_REMOVE]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_SOCIAL_OAUTH_SPECIAL_TELEGRAM_CALLBACK]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_SOCIAL_OAUTH_LINK_TMA]: SuccessResponseDtoSchema,

  //-------- REFERRAL --------
  [API_ENDPOINT.HUB_REFERRAL_CODE]: ReferralCodeResponseSchema,
  [API_ENDPOINT.HUB_REFERRAL_ACCEPT]: referralSchema,
  [API_ENDPOINT.HUB_REFERRAL_ELIGIBILITY]: ReferrerEligibilityProgressSchema,
  [API_ENDPOINT.HUB_REFERRALS]: UserReferralsSchema,
  [API_ENDPOINT.HUB_REFEREE_ELIGIBILITY_PROGRESS]: RefereeEligibilityProgressSchema,
  [API_ENDPOINT.HUB_REFERER_WEEKLY_ELIGIBILITY_PROGRESS]: ReferralEligibilityTargetAndCurrentDecimalSchema,
  [API_ENDPOINT.HUB_REFERRAL_REWARDS_CLAIMABLE]: ClaimableRewardsResponseSchema,
  [API_ENDPOINT.HUB_REFERRAL_SETTINGS]: ReferralSettingsResponseSchema,
  [API_ENDPOINT.HUB_REFERRER_STATS]: ReferrerStatsSchema,
  [API_ENDPOINT.HUB_REFEREE_STATS]: RefereeStatsSchema,
  [API_ENDPOINT.HUB_REFEREE_ELIGIBLE]: RefereeEligibleResponseSchema,
  [API_ENDPOINT.HUB_REFERRAL_AMBASSADOR_ELIGIBILITY]: AmbassadorEligibilityResponseSchema,

  //-------- REFERRAL MONITORING --------
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_CODE_COUNT]: NumberSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_REFEREES_COUNT]: RefereesCountSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_VOLUME_BY_REFEREE]: VolumeByRefereeSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_VOLUME_BY_EXCHANGE]: VolumeByExchangeSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_REWARDS_STATISTICS]: RewardsStatisticsSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_VOLUME_BY_REFERRER]: VolumeByReferrerSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_REFERRER_REFEREES]: ReferrerReferreesSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_REFERRER_DETAILS]: ReferrerDetailsSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_ACTIVE_REFEREES]: ActiveRefereesSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_REFERRAL_STATUS_RATE]: ReferralStatusRateSchema,
  [API_ENDPOINT.HUB_REFERRAL_MONITORING_QUEST_COMPLETION_TIME]: NullableStringSchema,
  [API_ENDPOINT.HUB_REFERRAL_ADMIN_GENERATE_REFERRAL_CODE]: ReferralCodeSchema,

  //-------- QUEST --------
  [API_ENDPOINT.QUEST_LIVE]: z.array(QuestDtoSchema),
  [API_ENDPOINT.QUEST_TMA_ONBOARDING_LIVE]: z.array(QuestDtoSchema),
  [API_ENDPOINT.QUEST_CLAIM_REWARDS]: QuestCompletionSchema,
  [API_ENDPOINT.QUEST_USER_COMPLETIONS]: z.array(QuestCompletionSchema),
  [API_ENDPOINT.QUEST_USER_PROGRESS]: z.array(QuestProgressSchema),
  [API_ENDPOINT.QUEST_USER_ELIGIBILITY]: z.array(QuestEligibilityItemSchema),
  [API_ENDPOINT.QUEST_POST_DATA]: XPostDataWithCommentDtoSchema,
  [API_ENDPOINT.QUEST_COMMENT_AND_FOLLOW]: SuccessResponseDtoSchema,
  [API_ENDPOINT.QUEST_POST_AND_FOLLOW]: SuccessResponseDtoSchema,
  [API_ENDPOINT.QUEST_X_LIKE]: SuccessResponseDtoSchema,
  [API_ENDPOINT.QUEST_X_RETWEET]: SuccessResponseDtoSchema,
  [API_ENDPOINT.QUEST_X_FOLLOW]: SuccessResponseDtoSchema,

  //-------- LOTTERY --------
  [API_ENDPOINT.LOTTERY_USER_TICKETS]: UserTicketsResponseDtoSchema,

  //-------- TRADE TO EARN CAMPAIGNS --------
  [API_ENDPOINT.TRADE_TO_EARN_CAMPAIGNS]: TTECampaignSummaryResponseSchema,
  [API_ENDPOINT.TRADE_TO_EARN_CAMPAIGNS_AUTHENTICATED]: TTECampaignSummaryResponseSchema,
  [API_ENDPOINT.TRADE_TO_EARN_CAMPAIGN_BY_NAME]: TradeToEarnCampaignWithStatsSchema,
  [API_ENDPOINT.TRADE_TO_EARN_CAMPAIGN_BY_NAME_AUTHENTICATED]: TradeToEarnCampaignWithStatsSchema,
  [API_ENDPOINT.TRADE_TO_EARN_CAMPAIGN_BY_NAME_INTERNAL]: TradeToEarnCampaignWithStatsSchema,
  [API_ENDPOINT.TRADE_TO_EARN_CAMPAIGN_BY_REWARD_VAULT_ADDRESS]: TradeToEarnCampaignSummarySchema,

  //-------- CEDE ARENA --------
  [API_ENDPOINT.CEDE_ARENA_LEADERBOARD]: GetArenaGeneralLeaderboardResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_LEADERBOARD_POSITION]: GetArenaGeneralLeaderboardPositionResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_LEADERBOARD_STATS]: GetArenaGeneralLeaderboardStatsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_RECENT_WINS]: GetArenaRecentWinsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_WEEKLY_LEADERBOARD]: GetArenaWeeklyLeaderboardResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_WEEKLY_LEADERBOARD_POSITION]: GetArenaWeeklyLeaderboardPositionResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_WEEKLY_LEADERBOARD_POSITIONS]: GetArenaWeeklyLeaderboardPositionsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_WEEKLY_LEADERBOARD_CROWNS]: GetArenaWeeklyCrownsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_PLAYER_PROFILE]: GetArenaPlayerProfileResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_PLAYER_IDENTITIES]: GetArenaPlayerIdentitiesResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_ME_ENTRY]: GetMyArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_OPT_IN]: GetMyArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_TICKETS]: GetMyArenaTicketsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_REFERRALS]: GetArenaReferralsResponseSchema,
  // The claim returns the refreshed page state, so the client needs no second read.
  [API_ENDPOINT.CEDE_ARENA_REFERRALS_CLAIM]: GetArenaReferralsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_REFERRALS_APPLY]: ApplyArenaReferralCodeResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_STATUS]: GetArenaKolManagerStatusResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER]: GetArenaKolManagerDashboardResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_CLAIM]: GetArenaKolManagerDashboardResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_VOLUME]: GetArenaKolManagerVolumeResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_KOLS]: ArenaKolWriteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_KOL_DETAIL]: GetArenaKolDetailResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_KOL_SPLIT]: ArenaKolWriteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_INVITES]: ArenaKolInviteDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_INVITE]: GetArenaKolInviteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_INVITE_ACCEPT]: GetArenaKolInviteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_ROLE_INVITE]: GetArenaKolManagerRoleInviteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_KOL_MANAGER_ROLE_INVITE_ACCEPT]: GetArenaKolManagerRoleInviteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CLANS]: GetArenaClansResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CLAN_BADGES]: GetArenaClanBadgesResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CLAN_ME]: GetMyArenaClanResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CLAN_LEAVE]: GetMyArenaClanResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CLAN_BY_SLUG]: GetArenaClanResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CLAN_INVITE_LINK]: GetArenaClanInviteLinkResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CLAN_JOIN]: GetMyArenaClanResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_QUEST_STATE]: GetMyArenaQuestStateResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_QUEST_PREVIEW]: ArenaQuestPreviewResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_TICKET_LINK]: ArenaTicketLinkPreviewResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_TICKET_LINK_CLAIM]: ClaimArenaTicketLinkResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CAMPAIGN_OPT_IN]: CedeArenaCampaignOptInResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CAMPAIGN_OPT_OUT]: CedeArenaCampaignOptInResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_MY_CAMPAIGN_OPT_INS]: CedeArenaMyCampaignOptInsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CAMPAIGN_OPT_IN_COUNTS]: CedeArenaCampaignOptInCountsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CAMPAIGN_JOINERS]: CedeArenaCampaignJoinersResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_READY]: GetMyArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_DECLINE]: GetMyArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_ONBOARDING_COMPLETE]: CompleteArenaOnboardingResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_ONBOARDING_SKIP]: SkipArenaOnboardingResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_ONBOARDING_STATE]: ArenaOnboardingProjectionSchema,
  [API_ENDPOINT.CEDE_ARENA_LEAVE]: GetMyArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_DISCORD_STATUS]: GetArenaDiscordStatusResponseSchema,
  // GET, POST and skip all return the full qualification state.
  [API_ENDPOINT.CEDE_ARENA_QUALIFICATION]: ArenaQualificationStateSchema,
  [API_ENDPOINT.CEDE_ARENA_QUALIFICATION_SKIP]: ArenaQualificationStateSchema,
  [API_ENDPOINT.CEDE_ARENA_SURVEY]: ArenaSurveyStateSchema,
  [API_ENDPOINT.CEDE_ARENA_SURVEY_SKIP]: ArenaSurveyStateSchema,
  [API_ENDPOINT.CEDE_ARENA_MARKET_FAVORITES]: ArenaMarketFavoritesSchema,
  [API_ENDPOINT.CEDE_ARENA_QUEUE_STATUS]: GetArenaQueueStatusResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_TRAFFIC_CURVE]: ArenaTrafficCurveDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_GEO_ELIGIBILITY]: GetArenaGeoEligibilityResponseSchema,
  [API_ENDPOINT.CONSENT_REGION]: GetConsentRegionResponseSchema,
  [API_ENDPOINT.CONSENT_RECORD]: VoidResponseDtoSchema,
  [API_ENDPOINT.SERVER_TIME]: z.object({ now: z.number() }),
  [API_ENDPOINT.CEDE_ARENA_REMATCH_PROPOSE]: GetMyArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FRIENDS]: GetArenaFriendsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FRIENDS_LIST]: GetArenaFriendsListResponseSchema,
  // Every mutation answers with the fresh relation state (friend ids, pending,
  // outgoing), so one response reseeds every friend button and the marker.
  [API_ENDPOINT.CEDE_ARENA_FRIENDS_REQUEST]: GetArenaFriendsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FRIENDS_REQUEST_RESPOND]: GetArenaFriendsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FRIENDS_REMOVE]: GetArenaFriendsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FRIENDS_LOOKUP]: LookupArenaFriendResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FRIENDS_INVITE_CREATE]: CreateArenaFriendInviteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FRIENDS_INVITE_CLAIM]: ClaimArenaFriendInviteResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_REMATCH_ELIGIBILITY]: GetArenaRematchEligibilityResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FORFEIT]: GetMyArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FORFEIT_ELIGIBILITY]: GetArenaForfeitEligibilityResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_CREATE_ROOM]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_MY_ROOMS]: MyPrivateCompetitionRoomsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_GET_ROOM]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_JOIN_ROOM]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_LEAVE_ROOM]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_KICK_PARTICIPANT]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_UPDATE_CONFIG]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_START]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_CANCEL_ROOM]: PrivateCompetitionRoomDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_PRIVATE_RAKE_POLICY]: GetArenaPrivateCompetitionRakePolicyResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FINALIZATION]: ArenaCompetitionFinalizationSchema,
  [API_ENDPOINT.CEDE_ARENA_CAMPAIGN_ACCOUNT_PNLS]: ArenaCampaignAccountPnlsSchema,
  [API_ENDPOINT.CEDE_ARENA_BATTLE_ROYALE_STATE]: BattleRoyaleStateDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_CANCELLED_COMPETITION]: ArenaCancelledCompetitionDtoSchema,
  [API_ENDPOINT.CEDE_ARENA_BATTLE_RECORD]: ArenaBattleRecordSchema,
  [API_ENDPOINT.CEDE_ARENA_OPENING_MOVE]: GetArenaOpeningMoveResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_ME_CAMPAIGN_STAKE]: ArenaMyCampaignStakeSchema.nullable(),
  [API_ENDPOINT.CEDE_ARENA_PAYOUT_CAPS_INTERNAL]: ArenaCampaignPayoutCapsDtoSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_ENTRIES]: AdminListArenaEntriesResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_OVERVIEW_KPIS]: ArenaOpsOverviewKpisResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_OVERVIEW_COVERAGE_RINGS]: ArenaOpsOverviewCoverageRingsResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_OVERVIEW_RECONCILIATION]: ArenaOpsOverviewReconciliationResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_USERS]: ArenaOpsUsersResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_USERS_KPIS]: ArenaOpsUsersKpisResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_USERS_LEDGER_IDENTITY]: ArenaOpsUsersLedgerIdentityResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_USERS_BALANCE_DISTRIBUTION]: ArenaOpsUsersBalanceDistributionResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_USERS_MOVEMENTS]: ArenaOpsUsersMovementsResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_PERIOD_FLOWS]: ArenaOpsMoneyPeriodFlowsResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_HOUSE_INJECTION]: ArenaOpsMoneyHouseInjectionResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_RAKE_PROVENANCE]: ArenaOpsMoneyRakeProvenanceResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_REVENUE_PER_DAY]: ArenaOpsMoneyRevenuePerDayResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_DEPOSITS]: ArenaOpsMoneyDepositsResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_WITHDRAWALS]: ArenaOpsMoneyWithdrawalsResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_FREE_TICKET_VALUE]: ArenaOpsMoneyFreeTicketValueResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_SANKEY]: ArenaOpsMoneySankeyResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_MOVEMENTS]: ArenaOpsMoneyMovementsResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MONEY_WITHDRAWAL_REQUESTS]: ArenaOpsMoneyWithdrawalRequestsResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_TICKETS_LIFECYCLE]: ArenaOpsTicketsLifecycleResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_TICKETS_BY_SOURCE]: ArenaOpsTicketsBySourceResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_TICKET_LINKS]: ArenaOpsTicketLinksResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_TICKETS_OUTCOMES]: ArenaOpsTicketsOutcomesResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_UNIVERSE]: ArenaOpsMatchmakingUniverseResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_PAIRING_RATE_SERIES]: ArenaOpsMatchmakingPairingRateSeriesResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_WAIT_SERIES]: ArenaOpsMatchmakingWaitSeriesResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_WAIT_CDF]: ArenaOpsMatchmakingWaitCdfResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_ENTRIES_BY_BUY_IN]: ArenaOpsMatchmakingEntriesByBuyInResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_QUEUE_HEALTH]: ArenaOpsMatchmakingQueueHealthResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_MATCHES_BY_HOUR]: ArenaOpsMatchmakingMatchesByHourResponseSchema,
  [API_ENDPOINT.ADMIN_ARENA_OPS_MATCHMAKING_QUEUE_DEPTH]: ArenaOpsMatchmakingQueueDepthResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_MARK_PAID]: AdminMarkArenaEntryPaidResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_CANCEL]: AdminCancelArenaEntryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_BALANCE]: GetArenaVirtualBalanceResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_DEPOSIT_ADDRESS]: GetArenaDepositAddressResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_DEPOSIT]: CreateArenaDepositResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_DEPOSIT_METHOD]: RecordArenaDepositMethodResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_DEPOSIT_METHODS]: GetArenaDepositMethodsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CROSSMINT_SETUP]: GetArenaCrossmintSetupResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CROSSMINT_WALLET]: RegisterArenaCrossmintWalletResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CROSSMINT_WALLET_VERIFY]: VerifyArenaCrossmintWalletResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CROSSMINT_ORDERS]: CreateArenaCrossmintOrderResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CROSSMINT_ORDER]: GetArenaCrossmintOrderResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CROSSMINT_OPEN_ORDERS]: GetArenaOpenCrossmintOrdersResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_WITHDRAW]: CreateArenaWithdrawResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_WITHDRAWS]: ListArenaWithdrawsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_WITHDRAW_CLAIM]: GetArenaWithdrawClaimResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_MOVEMENTS]: ListArenaBalanceMovementsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_RECENT_PAYOUTS]: ListArenaRecentPayoutsResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_FEED]: ListArenaFeedResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CHAT_MESSAGES]: GetArenaChatHistoryResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_CHAT_SEND]: SendArenaChatMessageResponseSchema,
  [API_ENDPOINT.ARENA_SUPPORT_CONVERSATION]: GetArenaSupportConversationResponseSchema,
  [API_ENDPOINT.ARENA_SUPPORT_MESSAGES]: GetArenaSupportMessagesResponseSchema,
  [API_ENDPOINT.ARENA_SUPPORT_SEND]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.ARENA_SUPPORT_SEEN]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.ARENA_SUPPORT_RESOLVE]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.ARENA_SUPPORT_RATE]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_CONVERSATIONS]: CmsArenaSupportConversationsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_MESSAGES]: CmsArenaSupportMessagesResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_REPLY]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_RESOLVE]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_TAKE_OVER]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_HAND_BACK]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_REVIEW_MESSAGE]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_KB]: CmsArenaSupportKbEntriesResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_KB_RETRY_EMBEDDING]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_PLAYGROUND]: CmsArenaSupportAgentPlaygroundResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_RUNS]: CmsArenaSupportAgentRunsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_GOLDEN]: CmsArenaSupportGoldenCasesResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_GOLDEN_CREATE]: ArenaSupportGoldenCaseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_GOLDEN_DELETE]: ArenaSupportAcceptedResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_EVAL_RUN]: CmsStartArenaSupportEvalRunResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_EVAL_RUNS]: CmsArenaSupportEvalRunsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_EVAL_RUN_BY_ID]: ArenaSupportEvalRunSchema,
  [API_ENDPOINT.CMS_ARENA_SUPPORT_AGENT_DASHBOARD]: CmsArenaSupportAgentDashboardResponseSchema,
  [API_ENDPOINT.CMS_ARENA_QUEUE_DISPLAY_SETTINGS]: ArenaQueueDisplaySettingsDtoSchema,
  [API_ENDPOINT.CMS_ARENA_REENGAGEMENT_SETTINGS]: ArenaReengagementSettingsDtoSchema,
  [API_ENDPOINT.CMS_ARENA_PRIVATE_COMPETITION_SETTINGS]: ArenaPrivateCompetitionSettingsDtoSchema,
  [API_ENDPOINT.CMS_ARENA_EVENT_SETTINGS]: ArenaEventConfigDtoSchema,
  [API_ENDPOINT.CMS_ARENA_MATCHMAKING_CONFIG]: GetArenaMatchmakingConfigsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_BOT_ATTRIBUTIONS]: GetArenaMatchmakingConfigsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_PLATFORM_SETTINGS]: ArenaPlatformSettingsDtoSchema,
  [API_ENDPOINT.CMS_ARENA_REFERRAL_SETTINGS]: ArenaReferralConfigDtoSchema,
  [API_ENDPOINT.CMS_ARENA_REFERRERS_GET_BY_PAGE]: ListCmsArenaReferrersResponseSchema,
  [API_ENDPOINT.CMS_ARENA_REFEREES_GET_BY_PAGE]: ListCmsArenaRefereesResponseSchema,
  [API_ENDPOINT.CMS_ARENA_REFERRAL_OVERRIDES]: ArenaReferralOverrideWriteResponseSchema,
  [API_ENDPOINT.CMS_ARENA_REFERRAL_OVERRIDES_GET_BY_PAGE]: ListArenaReferralOverridesResponseSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGERS]: ArenaKolManagerWriteResponseSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGERS_GET_BY_PAGE]: ListCmsArenaKolManagersResponseSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGER_KOLS]: ListCmsArenaKolsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGER_KOLS_UNLINK]: ArenaKolWriteResponseSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGER_KOLS_REASSIGN]: ArenaKolWriteResponseSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGER_EVENTS]: ListCmsArenaKolLinkEventsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGER_ROLE_INVITES]: CmsArenaKolManagerRoleInviteDtoSchema,
  [API_ENDPOINT.CMS_ARENA_KOL_MANAGER_ROLE_INVITES_GET_BY_PAGE]: ListCmsArenaKolManagerRoleInvitesResponseSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_SETTINGS]: ArenaClanConfigDtoSchema,
  [API_ENDPOINT.CMS_ARENA_CLANS_GET_BY_PAGE]: ListCmsArenaClansResponseSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_GET_BY_ID]: CmsArenaClanDtoSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_SAVE]: CmsArenaClanDtoSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_MEMBERS_GET_BY_PAGE]: ListCmsArenaClanMembersResponseSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_ASSIGN_CHIEF]: CmsArenaClanDtoSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_REMOVE_MEMBER]: CmsArenaClanDtoSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_TOURNAMENTS_GET_BY_PAGE]: ListCmsArenaClanTournamentsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_TOURNAMENT_GET_BY_ID]: GetCmsArenaClanTournamentResponseSchema,
  [API_ENDPOINT.CMS_ARENA_CLAN_TOURNAMENT_SAVE]: GetCmsArenaClanTournamentResponseSchema,
  [API_ENDPOINT.CMS_ARENA_SURVEY_SETTINGS]: ArenaSurveyConfigSchema,
  [API_ENDPOINT.CMS_ARENA_SURVEY_RESPONSES]: ListArenaSurveyResponsesResponseSchema,
  [API_ENDPOINT.CMS_ARENA_QUALIFICATION_SETTINGS]: ArenaQualificationConfigSchema,
  [API_ENDPOINT.CMS_SPIN_AND_GO_CONFIG]: GetSpinAndGoConfigsResponseSchema,
  [API_ENDPOINT.CMS_SPIN_AND_GO_MULTIPLIERS]: GetSpinAndGoUnconsumedResponseSchema,
  [API_ENDPOINT.CMS_SPIN_AND_GO_MULTIPLIERS_VOID]: GetSpinAndGoUnconsumedResponseSchema,
  [API_ENDPOINT.SPIN_AND_GO_PUBLIC_CONFIG]: SpinAndGoPublicConfigResponseSchema,
  [API_ENDPOINT.CEDE_ARENA_MATCHMAKING_TIERS]: GetArenaMatchmakingTiersResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_BLUEPRINTS]: GetCedeArenaCompetitionBlueprintResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_BLUEPRINT_PREVIEWS]: ListCedeArenaCompetitionBlueprintsResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_BLUEPRINT_BY_ID]: GetCedeArenaCompetitionBlueprintResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_UNLINKED_COMPETITIONS]: ListUnlinkedArenaCompetitionsResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_COMPETITIONS]: ListArenaCompetitionsResponseSchema,
  [API_ENDPOINT.ADMIN_CEDE_ARENA_WHITELIST]: z.union([
    ListArenaWhitelistedUsersResponseSchema,
    ArenaWhitelistedUserDtoSchema,
    SuccessResponseDtoSchema,
  ]),
  [API_ENDPOINT.CMS_CANBERRAI_CONFIG]: CanberraiConfigDtoSchema,
  [API_ENDPOINT.CMS_CANBERRAI_PLAYER_DIFFICULTY]: CanberraiPlayerDifficultyDtoSchema,
  [API_ENDPOINT.CMS_EXPERIMENTS]: ExperimentDtoSchema.array(),
  [API_ENDPOINT.CMS_ARENA_STARTER_PACK]: GetArenaStarterPackResponseSchema,
  [API_ENDPOINT.CMS_ARENA_QUEST_REWARD]: GetArenaQuestRewardResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TICKET_CONFIGURATION]: GetArenaTicketConfigurationResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TICKETS_GRANT]: GetArenaTicketsForUserResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TICKETS_FOR_USER]: GetArenaTicketsForUserResponseSchema,
  [API_ENDPOINT.ARENA_AFFILIATE_APPLICATION_SUBMIT]: VoidResponseDtoSchema,
  [API_ENDPOINT.CMS_ARENA_AFFILIATE_APPLICATIONS_BY_PAGE]: ListArenaAffiliateApplicationsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_AFFILIATE_APPLICATION_BY_ID]: ArenaAffiliateApplicationDtoSchema,
  [API_ENDPOINT.CMS_ARENA_AFFILIATE_APPLICATION_SAVE_REVIEW]: ArenaAffiliateApplicationDtoSchema,
  [API_ENDPOINT.BIG_ARENA_COMPETITION_MY_REGISTRATION]: GetMyBigArenaCompetitionRegistrationResponseSchema,
  [API_ENDPOINT.BIG_ARENA_COMPETITION_MY_REGISTRATION_SUBMIT]: SubmitBigArenaCompetitionRegistrationResponseSchema,
  [API_ENDPOINT.CMS_BIG_ARENA_COMPETITION_REGISTRATIONS_BY_PAGE]: ListBigArenaCompetitionRegistrationsResponseSchema,
  [API_ENDPOINT.CMS_BIG_ARENA_COMPETITION_REGISTRATION_REVIEW]: BigArenaCompetitionRegistrationDtoSchema,
  [API_ENDPOINT.CMS_BIG_ARENA_COMPETITION_PRIORITY_CODES_BY_PAGE]: ListBigArenaCompetitionPriorityCodesResponseSchema,
  [API_ENDPOINT.CMS_BIG_ARENA_COMPETITION_PRIORITY_CODES_GENERATE]:
    GenerateBigArenaCompetitionPriorityCodesResponseSchema,
  [API_ENDPOINT.CMS_BIG_ARENA_COMPETITION_PRIORITY_CODE_UPDATE_LABEL]: BigArenaCompetitionPriorityCodeDtoSchema,
  [API_ENDPOINT.CMS_BIG_ARENA_COMPETITION_PRIORITY_CODE_DISABLE]: BigArenaCompetitionPriorityCodeDtoSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_ACTIVE]: ArenaActiveTournamentResponseSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_CURRENT]: ArenaCurrentTournamentResponseSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_GET]: ArenaTournamentDtoSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_ROUND_LEADERBOARD]: ArenaTournamentRoundLeaderboardResponseSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_SNIPER_BOARD]: ArenaTournamentSniperBoardResponseSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_STREAK_BOARD]: ArenaTournamentStreakBoardResponseSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_ME]: ArenaTournamentMeResponseSchema,
  [API_ENDPOINT.ARENA_TOURNAMENT_JOIN]: ArenaTournamentMeResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENTS]: ListCmsArenaTournamentsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_CREATE]: SaveArenaTournamentResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_BY_ID]: CmsArenaTournamentDtoSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_UPDATE]: SaveArenaTournamentResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_DELETE]: z.void(),
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_ROUND_LEADERBOARD]: ArenaTournamentRoundLeaderboardResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_SNIPER_BOARD]: ArenaTournamentSniperBoardResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_STREAK_BOARD]: ArenaTournamentStreakBoardResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_PARTICIPANTS]: ListCmsArenaTournamentParticipantsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_PARTICIPANT_DUELS]: ListCmsArenaTournamentDuelsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_VOIDED_DUELS]: ListCmsArenaTournamentVoidedDuelsResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TOURNAMENT_ACTION]: z.void(),
  [API_ENDPOINT.CMS_ARENA_TICKET_LINK_GET_BY_PAGE]: ListArenaTicketLinksResponseSchema,
  [API_ENDPOINT.CMS_ARENA_TICKET_LINK_GET_BY_ID]: CmsArenaTicketLinkDtoSchema,
  [API_ENDPOINT.CMS_ARENA_TICKET_LINK_SAVE]: CmsArenaTicketLinkDtoSchema,
  [API_ENDPOINT.CMS_ARENA_TICKET_LINK_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.CMS_ARENA_BOT_SCHEDULER_CONFIG]: ArenaBotSchedulerConfigDtoSchema,
  [API_ENDPOINT.CMS_ARENA_TRAFFIC_CURVE_CONFIG]: ArenaTrafficCurveConfigDtoSchema,
} as const;

export const APIResponseSchemaMapPart2 = {
  //-------- HOLD TO EARN --------
  [API_ENDPOINT.HOLD_TO_EARN_LIVE_CAMPAIGNS]: z.array(HoldToEarnCampaignSchema),
  [API_ENDPOINT.HOLD_TO_EARN_ALL_CAMPAIGNS]: z.array(HoldToEarnCampaignSchema),
  [API_ENDPOINT.HOLD_TO_EARN_CAMPAIGN_BY_NAME]: HoldToEarnCampaignSchema,
  [API_ENDPOINT.HOLD_TO_EARN_JOIN_CAMPAIGN]: JoinCampaignResponseSchema,
  [API_ENDPOINT.HOLD_TO_EARN_LEADERBOARD]: GetLeaderboardResponseSchema,
  [API_ENDPOINT.HOLD_TO_EARN_PARTICIPANT_STATUS]: GetParticipantStatusResponseSchema,
  [API_ENDPOINT.HOLD_TO_EARN_EPOCH_STATISTICS]: GetEpochStatisticsResponseSchema,
  [API_ENDPOINT.HOLD_TO_EARN_VALIDATE_DEFI_ADDRESS]: ValidateHubDefiAddressResponseSchema,

  //-------- SPINNING WHEEL --------
  [API_ENDPOINT.SPINNING_WHEEL_REWARDS]: ListRewardsResponseSchema,
  [API_ENDPOINT.SPINNING_WHEEL_TICKETS]: GetUserTicketsResponseSchema,
  [API_ENDPOINT.SPINNING_WHEEL_RESULTS]: GetUserSpinResultsResponseSchema,
  [API_ENDPOINT.SPINNING_WHEEL_THRESHOLD_PROGRESS]: GetThresholdProgressResponseSchema,
  [API_ENDPOINT.SPINNING_WHEEL_SPIN]: VoidResponseDtoSchema,
  [API_ENDPOINT.SPINNING_WHEEL_RECENT_WINNERS]: GetRecentWinnersResponseSchema,
  [API_ENDPOINT.SPINNING_WHEEL_TMA_ELIGIBILITY]: SpinningWheelEligibilityResponseSchema,

  //-------- EXCHANGE ACCOUNT --------
  [API_ENDPOINT.EXCHANGE_ACCOUNT_ADD_HYPERLIQUID]: GetHyperliquidAgentSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_APPROVE_HYPERLIQUID]: HyperliquidStatusSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_HYPERLIQUID_STATUS]: HyperliquidStatusSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_HYPERLIQUID_ELIGIBILITY]: HyperliquidReferrerEligibilityResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_ADD_PARADEX]: AddParadexAccountSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_GRVT_BUILDER_PREPARE]: GrvtBuilderPrepareResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_GRVT_BUILDER_AUTHORIZE]: AddGrvtAccountSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_ZEROONE_PREPARE]: z.any(),
  [API_ENDPOINT.EXCHANGE_ACCOUNT_ZEROONE_AUTHORIZE]: z.any(),
  [API_ENDPOINT.EXCHANGE_ACCOUNT_EXTENDED_PREPARE]: ExtendedPrepareResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_EXTENDED_AUTHORIZE]: AddExtendedAccountSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_ADD_HIBACHI]: AddHibachiAccountSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_CONNECT_HIBACHI_WALLET]: ConnectHibachiResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_CONNECT_HIBACHI_WALLET_TOTP]: AddHibachiAccountSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_CONNECT_HIBACHI_WALLET_GRANT]: ConnectHibachiResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_ADD_DECIBEL]: AddDecibelAccountSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_DECIBEL_DELEGATION_PREPARE]: PrepareDecibelDelegationResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_DECIBEL_DELEGATION_AUTHORIZE]: AuthorizeDecibelDelegationResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_ADD_HOTSTUFF]: GetHotstuffAgentSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_APPROVE_HOTSTUFF]: HotstuffStatusSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_KATANA_DELEGATION_PREPARE]: KatanaDelegationPrepareResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_KATANA_DELEGATION_AUTHORIZE]: AddKatanaAccountSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_RISE_PREPARE]: RisePrepareResultSchema,
  [API_ENDPOINT.EXCHANGE_ACCOUNT_RISE_AUTHORIZE]: AddRiseAccountSchema,

  //-------- VOUCHER --------
  [API_ENDPOINT.HUB_VOUCHER_REDEEM]: VoidResponseDtoSchema,

  //-------- SKYWALKER --------
  [API_ENDPOINT.HUB_SKYWALKER_STATS]: SkywalkerStatsSchema,
  [API_ENDPOINT.HUB_SKYWALKER_EPOCH_HOURLY_VOLUME]: EpochHourlyVolumeResponseSchema,
  [API_ENDPOINT.HUB_SKYWALKER_EPOCH_TRADERS]: SkywalkerEpochTraderStatsSchema,
  [API_ENDPOINT.HUB_SKYWALKER_CAMPAIGN_USERS]: SkywalkerCampaignUsersResponseSchema,
  [API_ENDPOINT.HUB_SKYWALKER_USER_VOLUME]: SkywalkerUserVolumeDetailSchema,
  [API_ENDPOINT.HUB_SKYWALKER_USER_GEOGRAPHY]: SkywalkerUserGeographySchema,
  [API_ENDPOINT.HUB_SKYWALKER_GLOBAL_USER_GEOGRAPHY]: SkywalkerGlobalUserGeographySchema,
  [API_ENDPOINT.HUB_SKYWALKER_HTE_CAMPAIGNS]: z.array(SkywalkerHteCampaignSchema),
  [API_ENDPOINT.HUB_SKYWALKER_HTE_STATS]: SkywalkerHteStatsSchema,
  [API_ENDPOINT.HUB_SKYWALKER_HTE_INTERNAL]: SkywalkerHteInternalSchema,

  //-------- HALL OF FAME --------
  [API_ENDPOINT.HALL_OF_FAME_SEASONS]: GetSeasonsResponseSchema,
  [API_ENDPOINT.HALL_OF_FAME_USER_RANK_DATA]: GetUserRankDataResponseSchema,
  [API_ENDPOINT.HALL_OF_FAME_TOP_50]: GetTop50ResponseSchema,
  [API_ENDPOINT.HALL_OF_FAME_COUNTDOWN_REWARDS]: HallOfFameCountdownRewardsResponseSchema,

  //-------- ONCHAIN SWAP --------
  [API_ENDPOINT.ONCHAIN_SWAP_QUOTE]: swapQuoteResponseSchema,
  [API_ENDPOINT.ONCHAIN_SWAP_PORTFOLIO]: portfolioResponseSchema,
  [API_ENDPOINT.ONCHAIN_SWAP_TOKEN_BY_ADDRESS]: SwapTokenByAddressResponseSchema,
  [API_ENDPOINT.ONCHAIN_SWAP_TOKENS_FOR_SWAP]: getTokensForSwapResponseSchema,
  [API_ENDPOINT.ONCHAIN_SWAP_DEX_PAIRS]: getDexPairsResponseSchema,
  [API_ENDPOINT.ONCHAIN_SWAP_SUBMIT_TRANSACTION]: submitOnchainTransactionResponseSchema,
  [API_ENDPOINT.ONCHAIN_SWAP_WALLET_AGE_ELIGIBILITY]: WalletAgeCheckResultSchema,
  [API_ENDPOINT.ONCHAIN_SWAP_SYSTEM_METADATA]: OnchainSystemMetadataSchema,

  //-------- CASHBACK --------
  [API_ENDPOINT.CASHBACK_STATUS]: CashbackStatusResponseSchema,
  [API_ENDPOINT.CASHBACK_CONFIG]: CashbackConfigResponseSchema,

  //-------- POLYMARKET --------
  [API_ENDPOINT.POLYMARKET_CREDENTIALS]: VoidResponseDtoSchema,
  [API_ENDPOINT.POLYMARKET_CREDENTIALS_CHECK]: PolymarketCredentialsCheckResponseSchema,
  [API_ENDPOINT.POLYMARKET_ORDERS]: VoidResponseDtoSchema,
  [API_ENDPOINT.POLYMARKET_EVENTS]: PolymarketEventsResponseSchema,
  [API_ENDPOINT.POLYMARKET_EVENTS_BY_IDS]: PolymarketEventsResponseSchema,

  //-------- SELF-REGISTER CAMPAIGNS --------
  [API_ENDPOINT.HUB_SELF_REGISTER_CAMPAIGNS_SUBMIT]: VoidResponseDtoSchema,

  //-------- CRYPTO.COM REFEREE --------
  [API_ENDPOINT.HUB_CRYPTOCOM_REFEREE_SUBMIT]: VoidResponseDtoSchema,

  //-------- AIRDROP FARMING --------
  [API_ENDPOINT.HUB_AIRDROP_FARMING_BOTS]: z.union([
    z.array(AirdropFarmingBotDtoSchema),
    AirdropFarmingBotDtoSchema,
    MessageResponseDtoSchema,
  ]),
  [API_ENDPOINT.HUB_AIRDROP_FARMING_BOTS_V2]: ListAirdropFarmingBotsResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_BOT_AGGREGATES]: AirdropFarmingBotAggregatesResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_BOT_PERFORMANCE]: AirdropFarmingBotPerformanceResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_MIN_CAPITAL]: AirdropFarmingMinCapitalResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_AVAILABLE_CAPITAL]: AirdropFarmingAvailableCapitalResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_SUGGEST_PAIRS]: AirdropFarmingSuggestPairsResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_FEE_TIER]: AirdropFarmingFeeTierResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_BUILDER_FEES]: AirdropFarmingBuilderFeesResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_LEADERBOARD]: AirdropFarmingLeaderboardResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_LEADERBOARD_STATS]: AirdropFarmingLeaderboardStatsResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_LEADERBOARD_POSITION]: AirdropFarmingLeaderboardPositionResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_PENDING_RATING]: AirdropFarmingPendingRatingResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_BOT_RATING]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_BOT_HIDE]: SuccessResponseDtoSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_ORDER_FILL_LEADERBOARD]: OrderFillLeaderboardResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_ORDER_FILL_LEADERBOARD_POSITION]: OrderFillLeaderboardPositionResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_ORDER_FILL_LEADERBOARD_STATS]: OrderFillLeaderboardStatsResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_ORDER_FILL_LEADERBOARD_VOLUMES]: OrderFillVolumesBySlugsResponseSchema,
  [API_ENDPOINT.HUB_AIRDROP_FARMING_MAINTENANCE_WINDOWS]: GetActiveMaintenanceWindowResponseSchema,

  //-------- DELTA-NEUTRAL --------
  [API_ENDPOINT.HUB_DELTA_NEUTRAL_BOTS]: z.union([
    z.object({ bots: z.array(DeltaNeutralBotDtoSchema) }),
    z.object({ message: z.string() }),
  ]),
  [API_ENDPOINT.HUB_DELTA_NEUTRAL_LEG_INFO]: DeltaNeutralLegInfoResponseSchema,
  [API_ENDPOINT.HUB_DELTA_NEUTRAL_BOT_HIDE]: SuccessResponseDtoSchema,

  //-------- ADMIN HOLD TO EARN --------
  [API_ENDPOINT.ADMIN_HTE_CAMPAIGNS]: HteCampaignPreviewsListResponseSchema,
  [API_ENDPOINT.ADMIN_HTE_CAMPAIGN_BY_NAME]: HteCampaignFullDataDtoSchema,

  //-------- ADMIN TRADE TO EARN --------
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_ANALYTICS_LIST]: z.array(CampaignAnalyticsListItemSchema),
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_ANALYTICS_EPOCHS]: CampaignAnalyticsEpochsSchema,
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_VAULT_DETAIL]: CampaignVaultDetailSchema,
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_ANALYTICS_EPOCH_GROUPS]: CampaignAnalyticsEpochGroupsSchema,
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_VAULT_LIST]: z.array(CampaignVaultListItemSchema),
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGNS]: z.union([
    z.array(TradeToEarnCampaignSummarySchema),
    MessageResponseDtoSchema,
  ]),
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_BY_NAME]: TradeToEarnCampaignSchema,
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_PREVIEWS]: AdminTTECampaignPreviewResponseSchema,
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_FULL_DATA_BY_NAME]: TradeToEarnCampaignWithPrivateFieldsSchema,
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_LIVE_EPOCHS]: LiveCampaignEpochsDataSchema,
  [API_ENDPOINT.ADMIN_TRADE_TO_EARN_CAMPAIGN_VOLUME_TARGETS]: z.array(EpochVolumeTargetComputationRecordSchema),
  [API_ENDPOINT.ADMIN_REWARD_TOKEN_METADATA]: RewardTokenMetadataResponseSchema,
  [API_ENDPOINT.ADMIN_REWARD_TOKEN_DEFAULT]: RewardTokenMetadataResponseSchema,

  //-------- ADMIN MONITORING --------
  [API_ENDPOINT.ADMIN_MONITORING_CAMPAIGNS]: ListMonitoredCampaignsResponseSchema,
  [API_ENDPOINT.ADMIN_MONITORING_CAMPAIGN_HEALTH]: GetCampaignHealthResponseSchema,

  //-------- ADMIN CAMPAIGN PARTNERS --------
  [API_ENDPOINT.ADMIN_CAMPAIGN_PARTNERS]: z.union([
    ListCampaignPartnersResponseSchema,
    MessageResponseDtoSchema,
    SaveCampaignPartnersResponseSchema,
  ]),
  [API_ENDPOINT.ADMIN_CAMPAIGN_PARTNER_BY_ID]: CampaignPartnerDtoSchema,

  //-------- ADMIN SOLO CMS --------
  [API_ENDPOINT.ADMIN_SOLO_CMS_FILES]: z.union([ListFilesResultSchema, SuccessResponseDtoSchema]),
  [API_ENDPOINT.ADMIN_SOLO_CMS_UPLOAD]: UploadFileResponseSchema,

  //-------- ADMIN CASHBACK --------
  [API_ENDPOINT.ADMIN_CASHBACK_CONFIG]: z.union([AdminCashbackConfigResponseSchema, SaveCashbackConfigResponseSchema]),

  //-------- ADMIN HUB USERS --------
  [API_ENDPOINT.ADMIN_HUB_USERS]: ListAdminHubUsersResponseSchema,
  [API_ENDPOINT.ADMIN_HUB_USERS_UPDATE]: SuccessResponseDtoSchema,
  [API_ENDPOINT.ADMIN_HUB_USERS_AVATAR]: SuccessResponseDtoSchema,
  [API_ENDPOINT.ADMIN_HUB_USERS_QUOTE]: SuccessResponseDtoSchema,

  //-------- ADMIN BLACKLIST --------
  [API_ENDPOINT.ADMIN_BLACKLIST]: z.union([ListBlacklistAddressesResponseSchema, SuccessResponseDtoSchema]),
  [API_ENDPOINT.ADMIN_BLACKLIST_BATCH_DELETE]: SuccessResponseDtoSchema,

  //-------- ADMIN WHITELIST --------
  [API_ENDPOINT.ADMIN_WHITELIST]: z.union([ListWhitelistAddressesResponseSchema, SuccessResponseDtoSchema]),

  //-------- ADMIN AUTOMATIC STREAK --------
  [API_ENDPOINT.ADMIN_AUTOMATIC_STREAK_CONFIG]: AutomaticStreakConfigSchema,
  [API_ENDPOINT.ADMIN_AUTOMATIC_STREAK_V2_EPOCHS]: EpochsWithStreaksResponseSchema,
  [API_ENDPOINT.ADMIN_AUTOMATIC_STREAK_V2_USERS]: AutopilotUsersResponseSchema,
  [API_ENDPOINT.ADMIN_AUTOMATIC_STREAK_V2_TRADES]: AutopilotTradesResponseSchema,
  [API_ENDPOINT.ADMIN_AUTOMATIC_STREAK_V2_QUEUE_ITEMS]: AdminGetStreakQueueItemsByCampaignResponseSchema,
  [API_ENDPOINT.ADMIN_AUTOMATIC_STREAK_V2_GRANT_PRIORITY_TICKETS]: AdminGrantPriorityTicketsResponseSchemaV2,

  //-------- ADMIN ONCHAIN CONFIG --------
  [API_ENDPOINT.ADMIN_ONCHAIN_CONFIG]: z.union([
    AdminOnchainConfigResponseSchema,
    UpdateOnchainConfigResponseDtoSchema,
  ]),

  //-------- ADMIN CPC --------
  [API_ENDPOINT.ADMIN_CPC_CREATE_SIMULATION]: CpcCreateSimulationResponseSchema,
  [API_ENDPOINT.ADMIN_CPC_LIST_SIMULATIONS]: CpcListSimulationsResponseSchema,
  [API_ENDPOINT.ADMIN_CPC_CANCEL_SIMULATION]: CpcCancelSimulationResponseSchema,
  [API_ENDPOINT.ADMIN_CPC_VERIFY_WALLET]: CpcVerifyWalletResponseSchema,
  [API_ENDPOINT.ADMIN_CPC_WALLET_PORTFOLIO]: portfolioResponseSchema,

  //-------- QUEST CMS --------
  [API_ENDPOINT.QUEST_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.QUEST_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.QUEST_CMS_GET_BY_ID]: SaveQuestDtoSchema.nullable(),
  [API_ENDPOINT.QUEST_CMS_GET_BY_PAGE]: z.array(SaveQuestDtoSchema),

  //-------- HUB BANNERS --------
  [API_ENDPOINT.HUB_BANNER_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.HUB_BANNER_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.HUB_BANNER_CMS_GET_BY_ID]: HubBannerDtoSchema,
  [API_ENDPOINT.HUB_BANNER_CMS_GET_BY_PAGE]: GetHubBannersByPageResultSchema,
  [API_ENDPOINT.HUB_BANNERS_ACTIVE]: GetActiveHubBannersResultSchema,

  //-------- TRADE AND EARN COMPETITIONS --------
  [API_ENDPOINT.CEDE_FLOW_TRADE_AND_EARN_COMPETITION_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.CEDE_FLOW_TRADE_AND_EARN_COMPETITION_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.CEDE_FLOW_TRADE_AND_EARN_COMPETITION_CMS_GET_BY_ID]: CedeFlowTradeAndEarnCompetitionDtoSchema,
  [API_ENDPOINT.CEDE_FLOW_TRADE_AND_EARN_COMPETITION_CMS_GET_BY_PAGE]:
    GetCedeFlowTradeAndEarnCompetitionsByPageResultSchema,
  [API_ENDPOINT.CEDE_FLOW_TRADE_AND_EARN_COMPETITIONS_ACTIVE]: GetActiveCedeFlowTradeAndEarnCompetitionsResultSchema,
  [API_ENDPOINT.CEDE_FLOW_TRADE_AND_EARN_COMPETITION_BY_SLUG]: CedeFlowTradeAndEarnCompetitionDtoSchema,
  [API_ENDPOINT.CEDE_FLOW_TRADE_AND_EARN_COMPETITION_BY_SLUG_INTERNAL]: CedeFlowTradeAndEarnCompetitionDtoSchema,

  //-------- HUB UPDATES --------
  [API_ENDPOINT.HUB_UPDATE_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.HUB_UPDATE_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.HUB_UPDATE_CMS_GET_BY_ID]: HubUpdateDtoSchema,
  [API_ENDPOINT.HUB_UPDATE_CMS_GET_BY_PAGE]: GetHubUpdatesByPageResultSchema,
  [API_ENDPOINT.HUB_UPDATES_PUBLISHED]: GetPublishedHubUpdatesResultSchema,

  //-------- ARENA ANNOUNCEMENTS --------
  [API_ENDPOINT.ARENA_ANNOUNCEMENT_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.ARENA_ANNOUNCEMENT_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.ARENA_ANNOUNCEMENT_CMS_GET_BY_ID]: ArenaAnnouncementDtoSchema,
  [API_ENDPOINT.ARENA_ANNOUNCEMENT_CMS_GET_BY_PAGE]: GetArenaAnnouncementsByPageResultSchema,
  [API_ENDPOINT.GEO_RESTRICTION_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.GEO_RESTRICTION_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.GEO_RESTRICTION_CMS_GET_BY_PAGE]: GetGeoRestrictionsByPageResultSchema,
  [API_ENDPOINT.ARENA_ANNOUNCEMENTS_PUBLISHED]: GetPublishedArenaAnnouncementsResultSchema,

  //-------- ONBOARDING STEPS --------
  [API_ENDPOINT.ONBOARDING_STEP_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.ONBOARDING_STEP_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.ONBOARDING_STEP_CMS_GET_BY_ID]: OnboardingStepDtoSchema,
  [API_ENDPOINT.ONBOARDING_STEP_CMS_GET_BY_PAGE]: GetOnboardingStepsByPageResultSchema,
  [API_ENDPOINT.ONBOARDING_STEPS_PUBLISHED]: GetPublishedOnboardingStepsResultSchema,

  //-------- TRADE TUTORIAL STEPS --------
  [API_ENDPOINT.TRADE_TUTORIAL_STEP_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.TRADE_TUTORIAL_STEP_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.TRADE_TUTORIAL_STEP_CMS_GET_BY_ID]: TradeTutorialStepDtoSchema,
  [API_ENDPOINT.TRADE_TUTORIAL_STEP_CMS_GET_BY_PAGE]: GetTradeTutorialStepsByPageResultSchema,
  [API_ENDPOINT.TRADE_TUTORIAL_STEPS_PUBLISHED]: GetPublishedTradeTutorialStepsResultSchema,

  //-------- SPINNING WHEEL CONFIGS --------
  [API_ENDPOINT.SPINNING_WHEEL_CONFIG_CMS_SAVE]: MessageResponseDtoSchema,
  [API_ENDPOINT.SPINNING_WHEEL_CONFIG_CMS_DELETE]: MessageResponseDtoSchema,
  [API_ENDPOINT.SPINNING_WHEEL_CONFIG_CMS_GET_BY_ID]: SpinningWheelConfigDtoSchema,
  [API_ENDPOINT.SPINNING_WHEEL_CONFIG_CMS_GET_BY_PAGE]: GetSpinningWheelConfigsByPageResultSchema,

  //-------- FEATURE FLAGS --------
  [API_ENDPOINT.FEATURE_FLAGS_CMS_CREATE]: FeatureFlagsCmsSuccessResponseSchema,
  [API_ENDPOINT.FEATURE_FLAGS_CMS_UPDATE]: FeatureFlagsCmsSuccessResponseSchema,
  [API_ENDPOINT.FEATURE_FLAGS_CMS_DELETE]: FeatureFlagsCmsSuccessResponseSchema,
  [API_ENDPOINT.FEATURE_FLAGS_CMS_BULK_CREATE]: FeatureFlagsBulkSuccessResponseSchema,
  [API_ENDPOINT.FEATURE_FLAGS_CMS_BULK_DELETE]: FeatureFlagsBulkSuccessResponseSchema,
  [API_ENDPOINT.FEATURE_FLAGS_CMS_GET_BY_PAGE]: GetFeatureFlagsByPageResultSchema,
  [API_ENDPOINT.HUB_FEATURE_FLAGS]: HubFeatureFlagsLegacyResponseSchema,
  [API_ENDPOINT.HUB_FEATURE_FLAGS_V2]: HubFeatureFlagsResponseSchema,

  //-------- CMS PERMISSIONS --------
  [API_ENDPOINT.CMS_PERMISSIONS_ME]: GetMyPermissionsResponseSchema,
  [API_ENDPOINT.CMS_PERMISSIONS_USERS]: z.union([
    GetAllUsersPermissionsResponseSchema,
    CmsPermissionsSuccessResponseSchema,
  ]),

  //-------- FUNDING RATES --------
  [API_ENDPOINT.FUNDING_RATE_SUMMARIES]: PaginatedFundingRateSummariesSchema,

  //-------- PAPER TRADING --------
  // Authoritative response shapes are the API DTOs under `apps/api/src/modules/paper-trading/`.
  // We use `z.any()` here — same convention as the other endpoints whose schemas
  // aren't yet centralized in `@cede/types` (e.g. ZEROONE prepare/authorize).
  // The hooks layer types the data via `useQuery<T>` generics + an explicit cast.
  [API_ENDPOINT.HUB_PAPER_TRADING_PLACE_ORDER]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_CANCEL_ORDER]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_CANCEL_ATTACHED_TRIGGERS]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_PREVIEW_ORDER]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_ACCOUNT]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_POSITIONS]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_SET_POSITION_TRIGGERS]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_CLEAR_POSITION_TRIGGERS]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_OPEN_ORDERS]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_FILLS]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_OHLCV]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_RWA_VENUES]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_PAIR_METAS]: z.any(),
  [API_ENDPOINT.HUB_PAPER_TRADING_PAIR_VOLATILITY]: z.any(),
} as const;

export type APIResponseSchemaMapType = typeof APIResponseSchemaMapPart1 & typeof APIResponseSchemaMapPart2;

/** The annotation keeps declaration emit short; `satisfies` keeps the every-endpoint check. */
export const APIResponseSchemaMap: APIResponseSchemaMapType = {
  ...APIResponseSchemaMapPart1,
  ...APIResponseSchemaMapPart2,
} satisfies Record<API_ENDPOINT, z.ZodTypeAny>;

export type APIResponseMap = {
  [K in keyof APIResponseSchemaMapType]: z.infer<APIResponseSchemaMapType[K]>;
};
